//init switch image
export default function initSwitchImage() {
    const toggleLink = document.querySelectorAll('.reval a');

    toggleLink.forEach(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const parent = el.closest('.reval');
            if (!parent.classList.contains('active')) {
                console.log('test')
                parent.classList.add('active');
            }
            else {
                parent.classList.remove('active');
            }
        });
    });
}